// extracted by mini-css-extract-plugin
export default {"toggle":"rewards_toggle__7b12f","disabled":"rewards_disabled__78600"};